/* @flow */

export const constants = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  MODAL_SAVE_DESIGN: 'MODAL_SAVE_DESIGN',
  MODAL_OPEN_DESIGN: 'MODAL_OPEN_DESIGN',
};

export type StateType = {
  modalProps: {},
  modalType: ?string,
};

type DataType = StateType;
type ConstantType = $Keys<typeof constants>;

export type ActionType = { data?: DataType, type: ConstantType };

export const actions = {
  showModal: (data: DataType): ActionType => ({ type: constants.SHOW_MODAL, data }),
  hideModal: (data: Object): ActionType => ({ type: constants.HIDE_MODAL, data }),
};

export default { constants, actions };



// WEBPACK FOOTER //
// ./src/actions/modal.js